module.exports = __webpack_public_path__ + "static/media/avatars_female_20.0c1a8a28.png";